export default "__VITE_ASSET__446f99ef__"